import React, { ReactNode, useState } from 'react';

import { cn } from '@/utils/cn';

type MouseOverMenuProps = {
  children: ReactNode;
  className?: string;
};

const MouseOverMenu = ({ children, className }: MouseOverMenuProps) => {
  const [isMouseOver, setIsMouseOver] = useState(false);

  const childrenArray = React.Children.toArray(children);
  const content = childrenArray.find(
    child =>
      React.isValidElement(child) && child.type === MouseOverMenu.Content,
  );
  const menu = childrenArray.find(
    child => React.isValidElement(child) && child.type === MouseOverMenu.Menu,
  );

  return (
    <div
      className={cn('relative', 'w-full', 'min-h-16', 'cursor-auto', className)}
      role="button"
      tabIndex={0}
      onMouseOver={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
      onFocus={() => {}}
      onBlur={() => {}}
    >
      {content}
      <div
        className={cn(
          ['absolute', 'top-0', 'right-0'],
          ['inline-flex', 'flex-col', 'justify-start', 'items-end', 'gap-1'],
          'drop-shadow-md',
          'transition-all',
          'duration-200',
          isMouseOver ? 'opacity-100' : 'invisible opacity-0',
        )}
      >
        {menu}
      </div>
    </div>
  );
};

MouseOverMenu.displayName = 'MouseOverMenu';

type MouseOverMenuContentProps = {
  children: React.ReactNode;
};
const MouseOverMenuContent: React.FC<MouseOverMenuContentProps> = ({
  children,
}) => children;
MouseOverMenuContent.displayName = 'MouseOverMenu.Content';

type MouseOverMenuMenuProps = {
  children: React.ReactNode;
};
const MouseOverMenuMenu: React.FC<MouseOverMenuMenuProps> = ({ children }) =>
  children;
MouseOverMenuMenu.displayName = 'MouseOverMenu.Menu';

MouseOverMenu.Content = MouseOverMenuContent;
MouseOverMenu.Menu = MouseOverMenuMenu;

export { MouseOverMenu };
